import {
  useUserPreference,
  useUpsertUserPreference,
} from '@/api/rpc/hooks/core/useUserPreference';
import {
  LanguagePreferenceSchema,
  type LanguagePreference,
  type UserLocale,
} from '@erp/rpc';

const DEFAULTS: LanguagePreference = { locale: 'en' };

export function useLanguagePreference(enabled = true) {
  const { data, isLoading } = useUserPreference('language', enabled);
  const { mutate, isPending } = useUpsertUserPreference();

  let preference = DEFAULTS;
  if (data) {
    const parsed = LanguagePreferenceSchema.safeParse(data.value);
    preference = parsed.success ? parsed.data : DEFAULTS;
  }

  const setLanguage = (locale: UserLocale) => {
    mutate({ key: 'language', value: { locale } });
  };

  return {
    locale: preference.locale,
    setLanguage,
    isLoading: enabled && isLoading,
    isSaving: isPending,
  };
}
